import packageJson from '../package.json';
import { normalizeLinkedInProviderId } from './utils/linkedin-provider-id';
import { parseLinkedInSsoDomains } from './utils/linkedin-sso-routing';

// ----------------------------------------------------------------------

export type ConfigValue = {
  appName: string;
  appVersion: string;
  serverUrl: string;
  auth: {
    method: 'supabase';
    skip: boolean;
    redirectPath: string;
    linkedInEnabled: boolean;
    linkedInProviderId: string;
    linkedInDomains: string[];
  };
  supabase: { url: string; key: string };
};

// ----------------------------------------------------------------------

export const CONFIG: ConfigValue = {
  appName: 'Bizly Router',
  appVersion: packageJson.version,
  serverUrl: import.meta.env.VITE_PUBLIC_SERVER_URL ?? '',
  /**
   * Auth.
   * @method supabase
   */
  auth: {
    method: 'supabase',
    skip: false,
    redirectPath: '/new',
    linkedInEnabled: import.meta.env.VITE_PUBLIC_LINKEDIN_SSO_ENABLED === 'true',
    linkedInProviderId: normalizeLinkedInProviderId(
      import.meta.env.VITE_PUBLIC_LINKEDIN_SSO_PROVIDER_ID ?? 'custom:okta-linkedin'
    ),
    // Addresses that may only sign in with LinkedIn. Keep in step with
    // bonni-backend's LINKEDIN_SSO_ALLOWED_DOMAINS.
    linkedInDomains: parseLinkedInSsoDomains(import.meta.env.VITE_PUBLIC_LINKEDIN_SSO_DOMAINS ?? 'linkedin.com'),
  },
  /**
   * Supabase
   */
  supabase: {
    url: import.meta.env.VITE_PUBLIC_SUPABASE_URL ?? '',
    key: import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY ?? '',
  },
};
